module.exports = __webpack_public_path__ + "img/idx-service-computer.08384b7.webp";